export default "__VITE_ASSET__BWoYMoA9__"